export interface AdminFilters {
  range: '7d' | '30d'
  source: string
  country: string
  status:
    | 'all'
    | 'success'
    | 'failed'
    | 'active'
    | 'suspended'
    | 'revoked'
    | 'pending'
    | 'qualified'
    | 'rejected'
  query: string
}

const ADMIN_NAV_ITEMS: Array<{ path: string; label: string }> = [
  { path: '/admin', label: 'Overview' },
  { path: '/admin/acquisition', label: 'Acquisition' },
  { path: '/admin/signups', label: 'Signups' },
  { path: '/admin/logins', label: 'Logins' },
  { path: '/admin/users', label: 'Users' },
  { path: '/admin/promoters', label: 'Promoters' },
  { path: '/admin/referrals', label: 'Referrals' },
  { path: '/admin/coupons', label: 'Coupons' },
]

export function readAdminFiltersFromSearch(): AdminFilters {
  if (typeof window === 'undefined') {
    return {
      range: '7d',
      source: '',
      country: '',
      status: 'all',
      query: '',
    }
  }

  const params = new URLSearchParams(window.location.search)
  const range = params.get('range')
  const status = params.get('status')

  return {
    range: range === '30d' ? '30d' : '7d',
    source: params.get('source') ?? '',
    country: params.get('country') ?? '',
    status:
      status === 'success' ||
      status === 'failed' ||
      status === 'active' ||
      status === 'suspended' ||
      status === 'revoked' ||
      status === 'pending' ||
      status === 'qualified' ||
      status === 'rejected'
        ? status
        : 'all',
    query: params.get('q') ?? '',
  }
}

export function buildAdminSearch(filters: AdminFilters): string {
  const params = new URLSearchParams()
  params.set('range', filters.range)

  if (filters.source.trim().length > 0) {
    params.set('source', filters.source.trim())
  }

  if (filters.country.trim().length > 0) {
    params.set('country', filters.country.trim().toUpperCase())
  }

  if (filters.status !== 'all') {
    params.set('status', filters.status)
  }

  if (filters.query.trim().length > 0) {
    params.set('q', filters.query.trim())
  }

  return params.toString()
}

export function hrefWithCurrentAdminSearch(path: string): string {
  if (typeof window === 'undefined') {
    return path
  }

  const qs = window.location.search
  if (!qs || qs === '?') {
    return path
  }

  return `${path}${qs}`
}

export function getAdminNavLinks(
  filters: AdminFilters
): Array<{ path: string; label: string; href: string }> {
  const qs = buildAdminSearch(filters)
  return ADMIN_NAV_ITEMS.map((item) => ({
    ...item,
    href: qs.length > 0 ? `${item.path}?${qs}` : item.path,
  }))
}

export function applyAdminFilters(filters: AdminFilters): void {
  const qs = buildAdminSearch(filters)
  const nextUrl = qs.length > 0 ? `${window.location.pathname}?${qs}` : window.location.pathname
  window.location.assign(nextUrl)
}
